// DESC: Isključeno pravilo "adriatic-hr/no-class-components" jer boundary mora biti class-na komponenta.
/* eslint-disable adriatic-hr/no-class-components */
import React from 'react';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import AxiosError from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/axiosError';

class AdriaticErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        error.moreInfo = errorInfo;
        reportError(error);
    }

    render() {
        const { hasError } = this.state;
        const { customFallback, children } = this.props;
        if (hasError) {
            // TODO: #58308 Privremeno, nakon comitt-a prve verzije će se uklonit ili doradit.
            // TODO: Ovo je za prvu ruku, triba napravit novu komponentu koja ima funkcionalnost refresh-a.
            return customFallback || <AxiosError />;
        }

        return children;
    }
}

export default AdriaticErrorBoundary;
